import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const ProfileTranslations = wrapTranslationsSchema({
	name: 'ProfileTranslations',
	title: 'Profile Translations',
	sanityId: 'profile',
	fields: {
		pageTitle: 'Profile',
		snowSectionTitle: 'SNOW',
		aribaSectionTitle: 'Ariba',
		supplierDbSectionTitle: 'TET levels',
		id: 'ID',
		manager: 'Manager',
		location: 'Location',
		email: 'Email',
		companyCode: 'Company Code',
		purchasingOrg: 'Purchasing Org',
		requestorRoles: 'Requestor Roles',
		localeIdUniqueName: 'Locale ID Unique Name',
		sapBillingAddress: 'SAP Billing Address',
		sapPlant: 'SAP Plant',
		purchasingUnit: 'Purchasing Unit',
		countryCode: 'Country Code',
		vanillaDeliverTo: 'Vanilla Deliver To',
		sapCostCenter: 'SAP Cost Center',
		tetId0: 'TET ID 0',
		tetId1: 'TET ID 1',
		tetId2: 'TET ID 2',
		tetId3: 'TET ID 3',
		tetId4: 'TET ID 4',
		tetId5: 'TET ID 5',

		userProfile: 'User Profile',
		profileInformation: 'Profile Information',
		alertManagement: 'Alert Management',
		problemDuringAlertRetrieval:
			'There was a problem while retrieving your alerts. Please try again later.',
		noAlerts: 'You have no alerts to manage',
		profileSections: 'Profile sections',
		settings: 'Settings',
		language: 'Language',
		savedForLater: 'Saved for Later',
		requests: 'Requests',
		favorites: 'Favorites',
		viewProfile: 'View Profile',
		purchasingInformation: 'Purchasing Information',
		browseOnBehalf: 'You browse on behalf of',
		browseOnBehalfButton: 'Browse on behalf of',
		resetToMe: 'Reset to me',
		changedField: 'Updated for the selected user',
		networkId: 'Network ID',
		employeeId: 'Employee ID',
		businessUnit: 'Business Unit',
		jobFamilyGroup: 'Job Family Group',
		department: 'Department',
		timeZone: 'Time zone',
		country: 'Country',
		aribaRequestor: 'Ariba Requestor',
		hasPurchaseGroup: 'Has Purchase Group',
		supplier: 'Supplier',
		yes: 'Yes',
		no: 'No',
	},
});
